export default __webpack_public_path__ + "static/media/tacquerialoscoyotes.a7bff11c.jpeg";